/* eslint-disable max-lines-per-function */
import AddAttendeesComponent from './add_attendees';
import { CalendarMeetingParams } from '../../params/redux/calendar';
import CardWrapper from '../wrapper/card';
import ColorPickerComponent from '../reusable/color_picker';
import { createGoogleMeetingThunk } from '../../redux/thunks/calendar';
import CustomDropdown from '../reusable/dropdown';
import CustomInput from '../reusable/input';
import LabelWrapper from '../wrapper/label';
import { nameSchema } from '../../schema';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { settingAddingGoogleMeeting, settingSelectedEvent } from '../../redux/slices/calendar';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

interface ValuesInterface {
    name: string;
    description: string;
    set_date: string;
    set_time: string;
    duration: string;
    platform: string;
    color_tag: 'danger' | 'success' | 'warning' | 'primary';
}

const AddGoogleMeetingComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const [attendees, setAttendees] = useState<string[]>([]);
    const { selectedEvent, loaders } = useSelector((state: RootState) => state.calendar);
    const { selectedCustomer } = useSelector((state: RootState) => state.customer);
    const { currentUser } = useSelector((state: RootState) => state.app);
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const minDate = `${yyyy}-${mm}-${dd}`;

    useEffect(() => {
        if (selectedEvent) {
            setAttendees(selectedEvent.meeting_attendees?.map((attendee) => attendee.email) || []);
        }
    }, []);

    const handleAddAttendee = (email: string) => {
        setAttendees([...attendees, email]);
    };

    const handleRemoveAttendee = (email: string) => {
        setAttendees(attendees.filter((attendee) => attendee !== email));
    };

    const submitHandler = async (values: ValuesInterface) => {
        try {
            let user_id = 0;
            if (id && currentUser?.role !== 'client') {
                user_id = selectedCustomer?.id || 0;
            } else {
                user_id = currentUser?.id as number;
            }
            const data: CalendarMeetingParams = {
                user_id,
                title: values.name,
                description: values.description,
                set_date: values.set_date,
                set_time: values.set_time,
                duration: parseInt(values.duration.split(' ')[0], 10),
                color_tag: values.color_tag,
                attendees,
                platform: values.platform
            };
            await dispatch(createGoogleMeetingThunk(data)).unwrap();
            await dispatch(settingAddingGoogleMeeting(false));
        } catch (e) {
            // Catch errors
        }
    };

    const onCancelHandler = () => {
        dispatch(settingAddingGoogleMeeting(false));
        dispatch(settingSelectedEvent(null));
    };

    const disabled = loaders.isCreating || loaders.isUpdating;

    return <Box padding="15px" minHeight="80vh" overflow="auto">
        <CardWrapper>
            <Box minHeight="80vh">
                <Typography variant="h5" align="center" fontWeight="600" mb={2}>
                    {selectedEvent ? 'Update' : 'Create'} Meeting Link
                </Typography>
                <Formik initialValues={{
                    name: selectedEvent?.event_name || '',
                    description: selectedEvent?.description || '',
                    set_date: selectedEvent?.set_date?.split('T')[0] || '',
                    set_time: selectedEvent?.set_time || '',
                    duration: selectedEvent?.duration || '15 min',
                    platform: selectedEvent?.platform === 'none' ? 'none' : 'meet',
                    color_tag: (selectedEvent?.color_tag as 'danger' | 'warning' | 'primary' | 'success') || 'danger'
                }} validationSchema={nameSchema} onSubmit={submitHandler}>
                    {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
                        <Form>
                            <Box>
                                <CustomInput
                                    fullWidth
                                    label="Event name"
                                    placeholder="Event Name"
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.name && Boolean(errors.name)} disabled={disabled}
                                    mandatoryFields={true}
                                />
                            </Box>
                            <Box display="flex" gap="10px" my={2}>
                                <CustomInput
                                    fullWidth
                                    type="date"
                                    label="Set Date"
                                    placeholder="DD-MM-YYYY"
                                    name="set_date"
                                    value={values.set_date}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    min={minDate}
                                    error={touched.set_date && Boolean(errors.set_date)} disabled={disabled}
                                    mandatoryFields={true}
                                /><CustomInput
                                    fullWidth
                                    type="time"
                                    label="Set Time"
                                    placeholder="HH-MM"
                                    name="set_time"
                                    value={values.set_time}
                                    onChange={handleChange('set_time')}
                                    onBlur={handleBlur('set_time')}
                                    error={touched.set_time && Boolean(errors.set_time)} disabled={disabled}
                                    mandatoryFields={true}
                                />
                                {/* <CustomDropdown
                                    fullWidth
                                    type="time"
                                    label="Set Time"
                                    placeholder="HH-MM"
                                    name="set_time"
                                    value={values.set_time}
                                    options={timesData.map((item) => ({
                                        label: item,
                                        value: item
                                    }))}
                                    onChange={(e) => setFieldValue('set_time', e.target.value)}
                                    onBlur={handleBlur('set_time')}
                                    error={touched.set_time && Boolean(errors.set_time)} disabled={disabled}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 500,
                                                overflowY: 'auto'
                                            }
                                        }
                                    }}
                                    sx={{ mb: 0 }}
                                /> */}
                                <Box width="100%">
                                    <LabelWrapper label="Duration" />
                                    <CustomDropdown
                                        options={['15 min', '30 min', '45 min', '60 min'].map((item) => ({
                                            label: item,
                                            value: item
                                        }))}
                                        value={values.duration}
                                        onChange={(e) => setFieldValue('duration', e.target.value)} disabled={disabled}
                                    /> </Box>
                            </Box>
                            <Box display="flex" gap="10px">
                                <Box width="100%">
                                    <LabelWrapper label="Select Platform" />
                                    <CustomDropdown
                                        options={[{ label: 'Google Meet', value: 'meet' }, { label: 'None', value: 'none' }]}
                                        value={values.platform}
                                        onChange={(e) => setFieldValue('platform', e.target.value)} disabled={disabled}
                                    /> </Box>
                                <Box width="100%">
                                    <LabelWrapper label="Color Tag" />
                                    <ColorPickerComponent
                                        selected={values.color_tag}
                                        onChange={(value: string) => setFieldValue('color_tag', value)}
                                    />
                                </Box>
                            </Box>
                            <Box>
                                <CustomInput
                                    fullWidth
                                    type="textarea"
                                    rows={4}
                                    label="Description"
                                    placeholder="Enter event description"
                                    name="description"
                                    value={values.description}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.description && Boolean(errors.description)} disabled={disabled}
                                />
                            </Box>
                            <Box>
                                <AddAttendeesComponent
                                    attendees={attendees}
                                    onAdd={handleAddAttendee}
                                    onRemove={handleRemoveAttendee}
                                />
                            </Box>
                            {/* Action Buttons */}
                            <Box display="flex" justifyContent="flex-end" mt={3} gap={2}>
                                <Button variant="outlined" color="primary" disabled={disabled} onClick={onCancelHandler}>
                                    Cancel
                                </Button>
                                <Button type="submit" variant="contained" disabled={disabled} color="primary">
                                    Create
                                </Button>
                            </Box>
                        </Form>
                    )}
                </Formik>
            </Box>
        </CardWrapper>
    </Box>;
};

export default AddGoogleMeetingComponent;